// This is a modal for Profilethree

import { Button as AIMEButton } from "tot-loft-component-library";

import styled from "@emotion/styled";

export default function ModalProfilethree({ onClose }) {
  return (
    <RootWrapperModalProfilethree>
      <Overlay>
        <Wrapper>
          <PopupMessages>
            <Left>
              <Frame1391>
                <HoldingMoney />
                <Congratulations>
                  This is not Goodbye, just see you later!
                </Congratulations>
                <AReferralYouMadeToVendorNameWasSuccessfulAndYouVeEarnedAFixedReferralRewardOfReward>
                  Thank you for being a part of our journey. We hope to see you
                  again in the future. <br />
                  If you ever feel like giving us another shot, we’ll be right
                  here — same vibes, same energy.
                </AReferralYouMadeToVendorNameWasSuccessfulAndYouVeEarnedAFixedReferralRewardOfReward>
                <Frame1400>
                  <AIMEButton
                    size="small"
                    onClick={() => alert("View Details clicked")}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      flex: "none",
                      borderRadius: "999px",
                      width: "251px",
                      background: "rgb(33, 37, 67)",
                      backgroundRepeat: "no-repeat",
                      backgroundSize: "contain",
                      backgroundPosition: "center",
                      boxSizing: "border-box",
                      padding: "16px 32px",
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        textOverflow: "ellipsis",
                        fontSize: "16px",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: "600",
                        lineHeight: "110%",
                        textAlign: "left",
                      }}
                    >
                      View Details
                    </span>
                  </AIMEButton>
                </Frame1400>
              </Frame1391>
            </Left>
          </PopupMessages>
        </Wrapper>
      </Overlay>
    </RootWrapperModalProfilethree>
  );
}

const RootWrapperModalProfilethree = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  border-radius: 32px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 63px 24px;
`;


const PopupMessages = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 912px;
  background: rgb(255, 255, 255);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  box-sizing: border-box;
  padding: 5px 0px;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 912px;
  box-sizing: border-box;
  padding: 24px 0px;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const HoldingMoney = styled.div`
  width: 174px;
  height: 174px;
  background: url(https://s3-alpha-sig.figma.com/img/cbaf/a21a/4146f19f102fb8d244ec20c0a1680ab9?Expires=1749427200&Key-Pair-Id=APKAQ4GOSFWCW27IBOMQ&Signature=CFxXfvrK35imQciUG~wH7xIyaUDO8sR-6aM03jPkAk0N9h0r0zOCIlhyUE27yqoHajC7dLHczBHgvs24WAe2PCTDbhFv49cEJKEgAjrXt9wsoBM8b3kUkIoHvS358LaL616U07DjAhPJDPTfHZLFn30SeXvtcNsOoYdoJbI0TCdJCiF2ueQMeQgAe7bpmieq3oCqvNUeQ0qmonNiltxTNFFQLgDX88YikQtioc8TJ3CiyeFIh3JOilY7A7eLSHX8HK9~fhONRL2OSxfLmGesTyUt9q-mVfD8lZB7qE0Tsi03YO8RynNPGfEzCkAFxubwLNT~Ex57ZqNL3N4lL5vE8w__);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;

const Congratulations = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 24px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const AReferralYouMadeToVendorNameWasSuccessfulAndYouVeEarnedAFixedReferralRewardOfReward = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 14px;
  font-family: Montserrat, sans-serif;
  font-weight: 500;
  line-height: 160%;
  text-align: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1400 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 16px;
  box-sizing: border-box;
`;

